import axios from "axios";
import { toast } from "react-toastify";
import logger from "./logService";

axios.defaults.baseURL = "https://jeroid-backend.herokuapp.com/api/v1";
// axios.defaults.baseURL = "http://localhost:3900/api/v1";

// Interceptor to log users out
// axios.interceptors.request.use(
//   (request) => {
//     window.location.href = "/logout";
//     console.log("Intercept to log out.");
//     return request;
//   },
//   (error) => {
//     console.log("It worked");
//     return Promise.reject(error);
//   },
// );

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedError) {
    logger.log(error);
    toast.error("An unexpected error occurred!");
  }
  return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common["x-auth-token"] = jwt;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
};
